var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"menu-item",class:{active: _vm.active},attrs:{"href":_vm.path},on:{"click":function($event){$event.preventDefault();return _vm.onClick.apply(null, arguments)}}},[_vm._v(" Tasks ")])}
var staticRenderFns = []

export { render, staticRenderFns }